import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { LoginComponent } from './pages/login/login.component';
import { SignupComponent } from './pages/signup/signup.component';
import { ResetComponent } from './pages/reset/reset.component';
import { ForgotComponent } from './pages/forgot/forgot.component';
import { ConnectWalletComponent } from './pages/connect-wallet/connect-wallet.component';
import { TransactiondetailsComponent } from './pages/transactiondetails/transactiondetails.component';
import { TokenTrackerComponent } from './pages/token-tracker/token-tracker.component';
import { ProposalsComponent } from './pages/proposals/proposals.component';
import { MyproposalComponent } from './pages/myproposal/myproposal.component';
import { RepresentativesComponent } from './pages/representatives/representatives.component';
import { VotesComponent } from './pages/votes/votes.component';
import { CommitteeComponent } from './pages/committee/committee.component';
import { TermsComponent } from './pages/terms/terms.component';
import { SrprofileComponent } from './pages/srprofile/srprofile.component';
import { TokenComponent } from './pages/token/token.component';
import { HomeComponent } from './pages/home/home.component';
import { ExplorerComponent } from './pages/explorer/explorer.component';
import { AccountComponent } from './pages/account/account.component';
import { ContractReadComponent } from './pages/contract-read/contract-read.component';
import { GovernanceBodiesComponent } from './pages/governance-bodies/governance-bodies.component';
import { ListValidatorsComponent } from './pages/list-validators/list-validators.component';
import { AuthguardGuard } from '../app/guards/authguard.guard';
import { TransDetailsComponent } from './pages/trans-details/trans-details.component';
import { TagComponent } from './pages/tag/tag.component';
import { BlockComponent } from './pages/block/block.component';
import { BlocksidComponent } from './pages/blocksid/blocksid.component';
import { TokenTransfersComponent } from './pages/token-transfers/token-transfers.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { TrxPriceComponent } from './pages/trx-price/trx-price.component';
import { ChartsComponent } from './pages/charts/charts.component';
import { NetworkChartsComponent } from './pages/network-charts/network-charts.component';
import { AccountsChartsComponent } from './pages/accounts-charts/accounts-charts.component';
import { TransactionChartsComponent } from './pages/transaction-charts/transaction-charts.component';
import { ContractChartsComponent } from './pages/contract-charts/contract-charts.component';
import { OtpComponent } from './pages/otp/otp.component';
import { ResendMailComponent } from './pages/resend-mail/resend-mail.component';

const routes: Routes = [
	{ path: '', component: HomeComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'activate_account', component: LoginComponent },
	{ path: 'signup', component: SignupComponent },
	{ path: 'reset_password', component: ResetComponent },
	{ path: 'forgot', component: ForgotComponent },
	{ path: 'otp', component: OtpComponent },
	{ path: 'resend_mail', component: ResendMailComponent },
	{ path: 'token-tracker', component: TokenTrackerComponent,  },
	{ path: 'proposals', component: ProposalsComponent },
	{ path: 'myproposals', component: MyproposalComponent },
	{ path: 'representatives', component: RepresentativesComponent,  },
	{ path: 'votes', component: VotesComponent, canActivate: [AuthguardGuard] },
	{ path: 'committee', component: CommitteeComponent },
		{ path: 'terms', component: TermsComponent },
	{ path: 'contact-us', component: TermsComponent },
	{ path: 'policy', component: TermsComponent },
	{ path: 'freeze-transaction/:txid', component: SrprofileComponent },
	{ path: 'explorer', component: ExplorerComponent },
	{ path: 'contract-read/:address', component: ContractReadComponent },
	{ path: 'contract-read', component: ContractReadComponent },
	{ path: 'governance-bodies', component: GovernanceBodiesComponent, canActivate: [AuthguardGuard] },
	{
		path: 'list-validators', component: ListValidatorsComponent, canActivate: [AuthguardGuard]
	},
	{
		path: 'pages', component: MainLayoutComponent,
		children: [
			{
				path: 'charts', component: ChartsComponent
			},
			{
				path: 'trx-price', component: TrxPriceComponent
			},
			{
				path :'network-chart',component :NetworkChartsComponent
			},
			{
				path :'network-chart/:name',component :NetworkChartsComponent
			},
			{
				path :'account-chart',component :AccountsChartsComponent
			},
			{
				path :'account-chart/:name',component :AccountsChartsComponent
			},
			{
				path :'transaction-chart',component :TransactionChartsComponent
			},
			{
				path :'transaction-chart/:name',component :TransactionChartsComponent
			},
			{
				path :'contract-chart',component :ContractChartsComponent
			}
		]
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' }), CommonModule],
	exports: [RouterModule]
})
export class AppRoutingModule { }
